import axios from 'axios'
import qs from 'qs'
import {Loading} from 'element-ui';
import { Message } from 'element-ui';

// 添加请求拦截器，在发送请求之前做些什么(**具体查看axios文档**)--------------------------------------------
axios.interceptors.request.use(function (config) {
  // 显示loading
  return config
}, function (error) {
  // 请求错误时弹框提示，或做些其他事
  return Promise.reject(error)
});

// 添加响应拦截器(**具体查看axios文档**)----------------------------------------------------------------
axios.interceptors.response.use(function (response) {
  // 对响应数据做点什么，允许在数据返回客户端前，修改响应的数据
  // 如果只需要返回体中数据，则如下，如果需要全部，则 return response 即可
  return response.data
}, function (error) {
  // 对响应错误做点什么
  return Promise.reject(error)
})

// 封装数据返回失败提示函数---------------------------------------------------------------------------
function errorState (response) {
  // 隐藏loading
  // 如果http状态码正常，则直接返回数据
  if (response.sucess) {
    // 如果不需要除了data之外的数据，可以直接 return response.data
    return response
  } else {
    if (response.code != 0) {
      //location.href = "/#/empmanager"
      return;
    }
    Message.error(response.message);
  }
}

// 封装数据返回成功提示函数---------------------------------------------------------------------------
function successState (res) {
  // 隐藏loading
  // 统一判断后端返回的错误码(错误码与后台协商而定)
  if (res.sucess) {
    //alert('success')
    return res
  }
  else{
    Message.error(res.message);
  }
}




export const requestUtil = {
  install:function (Vue)
  {
    Vue.prototype.request=function(method, url, params, showError) {
      //localStorage.setItem("storeid","d4415a55a08a4411b7db78d4a50575c3");
      //localStorage.setItem("storename","intebo");
      //localStorage.setItem("token","eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJBTU4wMDAwNDI3MSIsInN1YiI6IjE1MjAxOTgzNzYzIiwiaWF0IjoxNjM2MTAwNzEwLCJleHAiOjE2MzYxODcxMTB9.fTe62djx7XM31mH1GwZWg2lXUMeXkHSUcAonDknONDc");
      //localStorage.setItem("staffid","7ca02244b4094f45801c64646a160a5a");
      let token=localStorage.getItem("token");
      if(!token){
        token="";
      }
      if(url.indexOf("?")!=-1){
        url=url+"&token="+token+"&questType=dd";
      }
      else{
        url=url+"?token="+token+"&questType=dd";
      }
      let httpDefault = {
        method: method,
        baseURL: process.env.API_ROOT,
        url: url,
        // `params` 是即将与请求一起发送的 URL 参数
        // `data` 是作为请求主体被发送的数据
        params: method === 'GET' || method === 'DELETE' ? params : null,
        data: method === 'POST' ? qs.stringify(params) : null || method === 'POSTW' ? JSON.stringify(params) : null || method==="UPLOAD"?params:null,
      }

      if(httpDefault.method=="POSTW"){
        httpDefault.method="POST";
        httpDefault.headers={'content-type':'application/json'};
      }
      if(httpDefault.method=="UPLOAD"){
        httpDefault.method="POST";
        httpDefault.headers={"Content-Type": "multipart/form-data;boundary="+new Date().getTime()};
      }
      

      let load = Loading.service({ fullscreen: true });
      // 注意**Promise**使用(Promise首字母大写)
      return new Promise((resolve, reject) => {
        axios(httpDefault)
          // 此处的.then属于axios
          .then((res) => {
            load.close();
            successState(res)
            resolve(res)
          }).catch((response) => {
          load.close();
          errorState(response)
          reject(response)
        })
      })
    }

    Vue.prototype.$get = function (url, params, showError) {
      return this.request("GET", url, params, showError);
    }


    Vue.prototype.$post = function (url, params, showError) {
      return this.request("POST", url, params, showError);
    }

    Vue.prototype.$postw = function (url, params, showError) {
      return this.request("POSTW", url, params, showError);
    }
    Vue.prototype.$upload = function (url, params, showError) {
      return this.request("UPLOAD", url, params, showError);
    }

    Vue.prototype.$getUrlKey=function (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
    }
  }
}




// WEBPACK FOOTER //
// ./src/util/requestUtil.js